import { z } from 'zod'

// Base schema for file uploads
export const FileUploadSchema = z.instanceof(File).optional()

// Common validation messages
export const ValidationMessages = {
  required: (field: string) => `${field} is required`,
  maxLength: (field: string, max: number) =>
    `${field} must be less than ${max} characters.`,
  fileType: (type: string) => `Please select a valid ${type} file`,
  fileSize: (maxSize: string) => `File size must be less than ${maxSize}`,
} as const

// Common form field types
export type FileUploadField = z.infer<typeof FileUploadSchema>

// Profile form values
export interface ProfileFormValues {
  firstName: string
  lastName: string
  avatar?: File
}

// Organization profile form values
export interface OrgProfileFormValues {
  orgName: string
  department: string
  address1: string
  address2: string
  city: string
  state: string
  zip: string
  logo?: File
}
